import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import BannedScreen from "@/components/BannedScreen";

export default function ProtectedRoute({ children }) {
  const { user, ban, ipBan, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-12 w-12 rounded-full border-4 border-pink-200 border-t-pink-500 animate-spin" />
      </div>
    );
  }
  if (ipBan) return <BannedScreen ban={ipBan} ipBan />;
  if (!user) return <Navigate to="/" replace />;
  if (ban) return <BannedScreen ban={ban} />;
  return children;
}
